import aa from 'search-insights'

function addConversion({
    brandObjectId,
    brandQueryId,
    eventName,
    cardQuantity,
    userToken,
}: {
    brandQueryId: string
    brandObjectId: string
    eventName: string
    cardQuantity: number
    userToken: string
}) {
    if (brandObjectId && brandQueryId) {
        const arrayOfObjectIds: string[] = []
        Array.from({ length: cardQuantity }, (_, x) => {
            arrayOfObjectIds.push(brandObjectId)
        })

        aa('convertedObjectIDsAfterSearch', {
            eventName: eventName,
            userToken: userToken,
            index: process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME_BRANDS ?? '',
            queryID: brandQueryId,
            objectIDs: arrayOfObjectIds,
        })
    }
}

export default addConversion
